// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"t2-z","colorTextValue":"u2-z","swatches":"v2-z","collapseLink":"w2-z","isCollapsed":"x2-z","dropdown":"y2-z","disabled":"z2-z"};